import { connect } from 'react-redux';
import ConsentRequestsFilter from './ConsentRequestsFilter';
import { getTranslation } from "../../../reducers/common/localization";
import { getConsentRequestsFilterVisibility } from '../../../reducers/account/role';
import { 
    getCurrentConsentRequestsFilterStatus, 
    setCurrentConsentRequestsFilterStatus,
    getCurrentConsentRequestsFilterJob,
    setCurrentConsentRequestsFilterJob
} from "../../../reducers/consent/organizationConsents";

const mapStateToProps = state => {
    return {
        isVisible: getConsentRequestsFilterVisibility(state),
        currentStatus: getCurrentConsentRequestsFilterStatus(state),
        currentJob: getCurrentConsentRequestsFilterJob(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onChangeStatus: (status) => dispatch(setCurrentConsentRequestsFilterStatus(status)),
        onChangeJob: (job) => dispatch(setCurrentConsentRequestsFilterJob(job))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConsentRequestsFilter);



// WEBPACK FOOTER //
// ./src/components/organizationConsentManagement/consentRequestsFilter/ConsentRequestsFilter.container.js